import { SeatsIOSeat } from "~components/reservation/constants";
import { addPropertiesToSeats } from "~features/seated-reservation/helpers/addPropertiesToSeats";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getState, setState } from "../index";

interface ActionProps {
  seats: SeatsIOSeat[];
}

export const setSeats = (payload: ActionProps) => {
  log("setSeats", payload);

  const state = getState();

  if (!payload.seats.length) {
    // TODO: handle error?
    console.error("No `seats` passed to SET_SEATS");
    return;
  }

  const seats = addPropertiesToSeats({
    seats: payload.seats,
    multiBuyPromotions: state.multiBuyPromotions,
    eventTicketTypes: state.eventTicketTypes,
    releasedZones: state.releasedZones,
  });

  setState({
    seats,
    selectFailed: false,
  });
};
